<div class="container">
	<div class="d-flex py-2">
		<div class="me-2"><img src="assets/img/us_flag_small.png" role="presentation" alt="USA Flag Icon" /></div>
		<span class="me-4">An official website of the United States government</span>
		<a href="#" (click)="$event.preventDefault(); showDetails()" [attr.aria-expanded]="detailsShown ? 'true' : 'false'">
			Here's how you know<i class="fa fas ms-2" [ngClass]="{ 'fa-chevron-up': detailsShown, 'fa-chevron-down': !detailsShown }"></i>
		</a>
	</div>
	@if (detailsShown) {
		<div class="d-flex flex-row justify-content-evenly align-items-center mb-2">
			<div class="col-12 col-sm-3 p-2 d-flex">
				<img class="me-3" src="assets/img/icon-dot-gov.svg" role="presentation" />
				<div class="small">
					<p class="mb-0">
						<strong role="heading" aria-level="3">Official websites use .gov</strong><br />
						A <strong>.gov</strong> website belongs to an official government organization in the United States.
					</p>
				</div>
			</div>
			<div class="col-12 col-sm-3 p-2 d-flex">
				<img class="me-3" src="assets/img/icon-https.svg" role="presentation" />
				<div class="small">
					<p class="mb-0">
						<strong role="heading" aria-level="3">Secure .gov websites use HTTPS</strong>
						<br />A <strong>lock</strong> (<i class="fa fas fa-lock" role="img" aria-label="Locked padlock"></i>) or
						<strong>https://</strong> means you've safely connected to the .gov website. Share sensitive information only on official,
						secure websites.
					</p>
				</div>
			</div>
		</div>
	}
</div>
